import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import type { ComponentLike } from '@glint/template';

interface ExploreCardSignature {
  Args: {
    /** Benefit or tool name, the card's h3. */
    title: string;
    /** Two-line summary; longer copy is clamped. */
    description: string;
    /** Shown in the 48px tile at the top. */
    icon: ComponentLike<{ Element: SVGElement }>;
    /** "More to Explore" call-to-action line; omit it for Resources cards. */
    incentive?: string;
    /** Where the whole card links. */
    route: string;
    /** Dynamic segment for `@route`, when the route has one. */
    model?: string | number;
  };
  Element: HTMLAnchorElement;
}

/** Figma `Benefit Card` for the More to Explore and Resources grids; the whole card is the link. */
export default class ExploreCard extends Component<ExploreCardSignature> {
  get models() {
    const { model } = this.args;
    return model === undefined ? [] : [model];
  }

  <template>
    <LinkTo
      @route={{@route}}
      @models={{this.models}}
      class="tio-col gap-3 tio-card tio-card--radius-card tio-card--padding-sm tio-card--elevation-card tio-elevation-card-hover border tio-border-default"
      ...attributes
    >
      <div class="tio-row-center h-12 w-12 rounded-lg tio-bg-sunken">
        {{#let @icon as |Icon|}}
          <Icon class="tio-icon-xl" />
        {{/let}}
      </div>
      <div class="tio-col-extra-tight">
        <h3 class="tio-text-base-semibold tio-fg-primary">{{@title}}</h3>
        <p class="tio-text-sm-medium tio-fg-secondary line-clamp-2">{{@description}}</p>
      </div>
      {{#if @incentive}}
        <span class="tio-text-sm-semibold tio-fg-muted" data-test-dashboard-kit-explore-incentive>
          {{@incentive}}
        </span>
      {{/if}}
    </LinkTo>
  </template>
}
